import React, { Component } from "react";
import styled from "styled-components";


const ProgressBarWrapper = styled.div`
  @keyframes progress-bar-stripes {
    from {
      background-position: 40px 0;
    }
    to {
      background-position: 0 0;
    }
  }
  height: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);

  div {
    float: left;

    height: 100%;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
    transition: width 0.6s ease;

    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent
    );
    background-size: 40px 40px;
    background-color: #5cb85c;

    animation: ${({ results }) =>
      results ? "none" : "progress-bar-stripes 2s linear infinite"};
  }
`;

const ProgressBar = ({ results, timeleft, timelimit }) => {
  let seconds = timeleft%60;
  if(seconds < 10) {
    seconds = '0' + seconds
  }
  let minutes = Math.floor(timeleft/60)
  if(minutes < 10) {
    minutes = '0' + minutes
  }

  return <div results={Boolean(results).toString()}>

    <div
      style={{
        width: `${timeleft * (100 / timelimit)}%`,
        filter: `hue-rotate(${timeleft * (100 / timelimit) - 100}deg)`
      }}
    > 
      <span>{(minutes + ":"+ seconds)}</span>
    </div>

  </div>

};

export default class ProgressBarHOC extends Component {
  state = {
    timelimit: parseFloat(this.props.timelimit),
    timeleft: 0,
  };

  componentWillUnmount(){
    if(this.timerId){
      clearInterval(this.timerId);
    }
  }

  componentDidMount() {
    let { timelimit, results, invert, questionId } = this.props;
    this.setState({timelimit:timelimit, questionId: questionId})
    if (!results) {
      if (invert) {
        this.startTimerProgress(0, timelimit);
      } else {
        this.startTimerProgress(timelimit, timelimit);
      }
    }

  }

  componentWillReceiveProps=(nextProps)=>{
    if(this.props.questionId !== nextProps.questionId) {
      clearInterval(this.timerId);
      this.setState({timelimit: nextProps.timelimit, questionId: nextProps.questionId})
    }
  }

  componentDidUpdate=(prevProps, prevState)=>{
    if (prevState.questionId !== this.state.questionId) {
      clearInterval(this.timerId);
      this.startTimerProgress(this.state.timelimit, this.state.timelimit);
    }
  }


  startTimerProgress(timeleft, timelimit) {
    let { invert } = this.props
    if (this.state.testFinished) return;
    this.setState({ timeleft , timelimit});

    if (invert) {
      if (timeleft < timelimit) {
        this.timerId = setTimeout(() => {
          this.startTimerProgress(timeleft + 1, timelimit);
          this.props.updateTimers(this.timerId);
        }, 1000);
      } else {
        console.log('Timeout happended');
        this.props.handleTimeout();
      }
    } else {
      if (timeleft > 0) {
        this.timerId = setTimeout(() => {
          this.startTimerProgress(timeleft - 1, timelimit);
          this.props.updateTimers(this.timerId,timeleft);
        }, 1000);
      } else {
        console.log('Timeout happended');
        this.props.handleTimeout();
      }
    }


  }
  render() {
    let {  results, invert } = this.props;
    let {timelimit, timeleft } = this.state;
    console.log(timelimit)
    console.log(timeleft)
    if (results && !invert) {
      timeleft = timelimit;
    }
    return <ProgressBar {...{ timeleft, timelimit, results }} />;
  }
}
//Fixed progressbar issue.